import React from 'react';

const ThisUnitTable = (props) => {
    return (
        <tr key={props.index} className="image" onClick={() => props.editData(props.item)}>
            <td>
                {props.item.name}
            </td>
            <td>
                {props.item.shortname}
            </td>
        </tr>
    );
};

export default ThisUnitTable;